/**
 * LámFon User Level System
 * 
 * Level names with Lamnso' translations:
 *   1 — Beginner (Wán)
 *   2 — Speaker (Wà'bìn)
 *   3 — Storyteller (Ránsísí)
 *   4 — Elder (Wirfon)
 */

const LEVELS = {
  1: { en: 'Beginner', lamnso: 'Wán', combined: 'Wán (Beginner)', short: 'Wán' },
  2: { en: 'Speaker', lamnso: "Wà'bìn", combined: "Wà'bìn (Speaker)", short: "Wà'bìn" },
  3: { en: 'Storyteller', lamnso: 'Ránsísí', combined: 'Ránsísí (Storyteller)', short: 'Ránsísí' },
  4: { en: 'Elder', lamnso: 'Wirfon', combined: 'Wirfon (Elder)', short: 'Wirfon' },
};

/**
 * Get level display info.
 * @param {number} level - 1-4
 * @returns {{ en, lamnso, combined, short }}
 */
export function getLevelName(level) {
  return LEVELS[level] || LEVELS[1];
}

/**
 * Format level for display: "Wán (Beginner)" or just "Wán"
 * @param {number} level
 * @param {'combined'|'short'|'en'|'lamnso'} format
 */
export function formatLevel(level, format = 'combined') {
  const info = getLevelName(level);
  return info[format] || info.combined;
}

export { LEVELS };
